export const selectWidgetStatus = (state) => state.popups.widget.opened;
export const selectWidgetPosition = (state) => state.popups.widget.position;
